export const parseTinodeError = (err) => {
  if (!err) return "Unknown error";

  if (err instanceof Event || (err && err.isTrusted !== undefined)) {
    if (err.type === "error") {
      return "WebSocket connection failed. Please check if Tinode server is running.";
    }
    if (err.type === "close") {
      return "WebSocket connection closed. Please try again.";
    }
    return `WebSocket error: ${err.type || "connection failed"}`;
  }

  const errStr = String(err);
  if (errStr === "[object Event]") {
    return "WebSocket connection failed. Please check if Tinode server is running.";
  }

  if (err instanceof Error) {
    return err.message || "Unknown error";
  }

  if (err && typeof err === "object") {
    if (err.type === "error" || err.type === "close") {
      return err.type === "error"
        ? "WebSocket connection failed. Please check if Tinode server is running."
        : "WebSocket connection closed. Please try again.";
    }
    if (err.code === 409 || err.text === "already authenticated") {
      return null;
    }
    if (err.code === 503) {
      return "Tinode server not available (503). Please try again.";
    }
    if (err.code === 401) {
      return "Authentication required. Please login again.";
    }
    if (err.message) return err.message;
    if (err.text) return err.text;
    if (err.code) return `Error ${err.code}: ${err.text || "Unknown error"}`;

    if (errStr === "[object Object]") {
      return "WebSocket connection failed. Please check if Tinode server is running.";
    }
    return errStr;
  }

  return errStr || "Unknown error";
};

export const isNonFatalTinodeError = (err) => {
  const msg = parseTinodeError(err);
  if (!msg) return true;

  const nonFatalPatterns = [
    "already authenticated",
    "409",
    "timeout",
    "504",
    "Promise expired",
    "Message rejected",
    "reconnect",
    "no content",
    "204",
  ];

  return nonFatalPatterns.some((pattern) =>
    msg.toLowerCase().includes(pattern.toLowerCase()),
  );
};

export const waitForConnection = (tinode, timeoutMs = 10000) => {
  return new Promise((resolve, reject) => {
    if (tinode.isConnected()) {
      resolve();
      return;
    }

    const timeout = setTimeout(() => {
      reject(new Error(`Connection timeout after ${timeoutMs / 1000} seconds`));
    }, timeoutMs);

    const checkInterval = setInterval(() => {
      if (tinode.isConnected()) {
        clearInterval(checkInterval);
        clearTimeout(timeout);
        resolve();
      }
    }, 100);
  });
};
